<template>
  <div class="c-user__body">
    <pip-echart slot="filter" v-bind="$props" />
    <Viewport v-model="tableHeight">
      <el-table
        :data="tableData"
        :height="tableHeight - 6"
        :loading="asyning"
        :summary-method="summaries"
        border
        class="common-el-table-styles summary-el-table-styles"
        show-summary
        @sort-change="sortTable"
        ref="roleDataTable"
      >
        <el-table-column
          v-for="(col, id) in tableCol"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
          :sortable="col.sortable"
          :sort-orders="['descending', 'ascending', null]"
        >
          <template slot-scope="scope">
            <span v-if="['money', 'rolePayCount'].includes(col.key)">{{ scope.row[col.key] | toThousands }}</span>
            <span v-else-if="['createRoleTime', 'lastLoginTime'].includes(col.key)">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page pager"
        size="small"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </Viewport>

    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="tableColumns" :subTitle="['基础数据']" @on-select="selectCustomColumn" />
  </div>
</template>
<script>
import { HOST_API } from '@/api/config'
import { isArray, trim, throttle } from '@/common/js/utils'
import { toThousands } from '@/common/js/filters'
import tableColumns from '../../../data/user_role_columns'
import mixinTable from '../../mixin_table'

import CustomColumn from '@/components/converter/custom-column.vue'

import PipEchart from '../pip/echart'

import { getUserRolePage } from '@/api/ptom.data.model'
export default {
  name: 'UserRole',
  mixins: [mixinTable],
  components: { PipEchart, CustomColumn },
  props: {
    asyning: {
      type: Boolean
    },
    detailTime: {
      type: Array,
      required: true
    },
    platform: {
      type: Number
    },
    productId: {
      type: Number
    },
    chlUserId: {
      type: Number
    },
    sourceId: {
      type: Number
    },
    keyword: {
      type: String
    }
  },
  computed: {
    tableCol() {
      return this.tableColumns.filter((ret) => !ret.show)
    }
  },
  data() {
    return {
      modalColumn: null,
      tableData: [],
      tableColumns: [],
      sumdata: null,
      tableHeight: 300
    }
  },
  methods: {
    getData() {
      const [begin, end] = this.detailTime || []

      this.$emit('on-change', true)
      getUserRolePage({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        begTime: begin,
        enTime: end,
        keyword: trim(this.keyword),
        platform: this.platform,
        gameId: this.productId,
        chlId: this.chlUserId,
        sourceId: this.sourceId,
        sort: this.sort,
        order: this.order
      })
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.$emit('on-change', false)
            if (!data) return
            const { list, page_info, sum_data } = data
            if (isArray(list) && page_info && sum_data) {
              const { total_number } = page_info
              this.sumdata = sum_data
              this.initTableColumns()
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
            this.$nextTick(() => {
              this.$refs.roleDataTable && this.$refs.roleDataTable.doLayout()
            })
          }
        })
        .catch(() => {
          this.$emit('on-change', false)
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    initTableColumns() {
      const shows = this.getCustomStorage('UserRoleDataCustomColumn') // 同步本地存储自定义列
      if (shows.length) {
        const local_shows = shows
          .filter((ret) => ret)
          .map((ret) => {
            const item = tableColumns.filter((met) => met.key === ret).pop() || {}
            item.show = false
            return item
          })
        const extend_shows = tableColumns
          .filter((ret) => !shows.includes(ret.key))
          .map((ret) => {
            ret.show = true
            return ret
          })
        this.tableColumns = [...local_shows, ...extend_shows]
      } else this.tableColumns = [...tableColumns]
    },
    downData() {
      const [begin, end] = this.detailTime || []
      const url = `${HOST_API}/api/ptom/plandata/exportUserInfo?`

      const querystring = new URLSearchParams()
      querystring.append('sessionid', this.$store.state.token)
      querystring.append('platform', this.platform)
      querystring.append('gameId', this.productId)
      querystring.append('chlId', this.chlUserId)
      querystring.append('sourceId', this.sourceId)
      querystring.append('begTime', begin)
      querystring.append('enTime', end)
      if (this.keyword) querystring.append('keyword', this.keyword)
      if (this.order) querystring.append('order', this.order)
      if (this.sort) querystring.append('sort', this.sort)

      window.open(url + querystring.toString())
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        const val = prop && parseFloat(data[prop])
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const twoDecimal = ['roleName', 'money', 'rolePayCount', 'serverName']
        if (twoDecimal.includes(prop)) sums[index] = val
        else if (prop === 'orderMoney') sums[index] = toThousands(val)
        else sums[index] = ''
      })
      return sums
    },
    selectCustomColumn(params) {
      const tableColumns = params.sort((a, b) => (a._time || 0) - (b._time || 0))
      this.$set(this, 'tableColumns', tableColumns)
      this.modalColumn = false
    }
  },
  watch: {
    detailTime() {
      throttle(() => {
        this.pageIndex = 1
        this.getData()
      }, 300)()
    },
    tableColumns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage('UserRoleDataCustomColumn', show)
        this.$nextTick(() => {
          this.$refs.roleDataTable && this.$refs.roleDataTable.doLayout()
        })
      },
      deep: true
    }
  },
  created() {
    this.getData()
  },
  beforeDestroy() {
    this.tableData = []
    this.tableColumns = []
    this.total = 0
  }
}
</script>
<style lang="scss" scoped>
.c-user__body {
  height: 100%;
  padding-top: 5px;

  .c-table-page {
    padding-top: 7px;
    text-align: right;
  }
}
</style>
